import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";

import { ReadonlyEditor, plugins, FORMAT_TYPES } from "widgets/richtext";
import { UserIcon, AVATAR_SIZE } from "widgets/datadisplay";
import { Classes } from "base/classes";

import { Embedurl } from "../../components/post/embedurl";
import { Replies } from "./replies.drawer";
import { CommentAttachments } from "./comment.attachments";
import { useForumStore } from "../../common/store/forum.store";
import { CHANNEL_CONST } from "@/common/utils/constant";

import styles from "../../forum/forum.css";

export function CommentQuote({
  topicId,
  quoteContent,
  comment,
  parentComment,
  commentContent,
  attachments,
  isNoText,
  teamId
}) {
  const [isShowReplies, setShowReplies] = useState(false);
  const { isCurrentTopicDeleted } = useForumStore((state) => ({
    isCurrentTopicDeleted: state.isCurrentTopicDeleted
  }));

  const { customPlugins } = useMemo(function customPlugin() {
    return {
      customPlugins: [
        plugins.MentionPlugin,
        plugins.BoldPlugin,
        plugins.ItalicPlugin,
        plugins.LinkPlugin,
        plugins.UnderlinePlugin,
        plugins.StrikePlugin,
        plugins.ColorPlugin,
        plugins.ImagePlugin,
        {
          formatType: FORMAT_TYPES.EMBED_LINK,
          component: React.forwardRef((prop, ref) => {
            return (
              <Embedurl
                innerRef={ref}
                {...prop}
                title={CHANNEL_CONST.COMMENT}
              />
            );
          })
        }
      ]
    };
  }, []);
  const { isPostQuoted } = useMemo(
    function quoted() {
      return {
        isPostQuoted: quoteContent?.[0]?.data?.EntityType === CHANNEL_CONST.POST
      };
    },
    [quoteContent]
  );

  return (
    <div
      className={`${styles.quoteWrapper} ${
        isPostQuoted ? styles.topic : styles.comment
      } ${!isPostQuoted && parentComment ? styles.pointer : ""}`}
      onClick={() => {
        setShowReplies(true);
      }}
    >
      {parentComment?._created_by && !quoteContent?.[0]?.data?.EntityType && (
        <div className={styles.df8}>
          <UserIcon
            userId={parentComment._created_by._id}
            name={parentComment._created_by.Name}
            size={AVATAR_SIZE.SIZE20}
          />
          <div className="smallplus-600">{parentComment._created_by.Name}</div>
        </div>
      )}
      {!parentComment && !isPostQuoted ? (
        <i className={`base ${styles.deletedText}`}>This reply was deleted</i>
      ) : (
        <React.Fragment>
          {isNoText ? null : (
            <ReadonlyEditor
              value={quoteContent}
              renderer={customPlugins}
              className={`${styles.quoteEditor} ${Classes.baseplus400} ${Classes.ellipsis2}`}
            />
          )}
        </React.Fragment>
      )}
      <CommentAttachments attachments={attachments} readonly={true} />
      {comment &&
        commentContent &&
        !isPostQuoted &&
        parentComment &&
        !isCurrentTopicDeleted && (
          <Replies
            isShowReplies={isShowReplies}
            setShowReplies={() => {
              setShowReplies(false);
            }}
            values={[parentComment, { ...comment, Content: commentContent }]}
            key={`${comment._id}`}
            teamId={teamId}
            topicId={topicId}
          />
        )}
    </div>
  );
}

CommentQuote.propTypes = {
  topicId: PropTypes.string,
  quoteContent: PropTypes.object,
  comment: PropTypes.object,
  parentComment: PropTypes.object,
  commentContent: PropTypes.object,
  attachments: PropTypes.object,
  isNoText: PropTypes.bool,
  teamId: PropTypes.string
};
